import React, { useEffect, useState } from 'react';
import Pad from 'signature_pad';
import { FaEraser } from 'react-icons/fa';
import { toast } from 'react-toastify';
import useScreenSize from '../../hooks/useScreenSize';
import CustomButton from '../CustomButton/CustomButton';

interface SignaturePadParams {
  handleSignature: (dataUrl: string | undefined) => Promise<void>;
  signature?: string;
  width?: number;
  height?: number;
}

export default function SignaturePad({
  handleSignature,
  signature,
  width,
  height,
}: SignaturePadParams) {
  const [screenWidth, screenHeight] = useScreenSize();
  const [pad, setPad] = useState<Pad | null>(null);

  const readyPad = () => {
    const wrapper = document.getElementById('signature-pad');
    const canvas = wrapper?.querySelector('canvas');
    if (canvas) {
      canvas.width = (width ?? screenWidth) - 30;
      canvas.height = (height ?? screenHeight) - 75;

      setPad(
        new Pad(canvas, {
          penColor: 'rgb(0, 0, 0)',
          backgroundColor: 'rgb(255, 255, 255)',
        })
      );
    }
  };

  const clear = () => {
    if (pad) pad.clear();
  };

  const sign = async () => {
    if (pad?.isEmpty()) {
      toast.info('A Ordem de Serviço deve ser assinada antes de continuar');
      return;
    }
    await handleSignature(pad?.toDataURL());
  };

  useEffect(() => {
    readyPad();
  }, [screenWidth, screenHeight]);

  useEffect(() => {
    if (pad && signature) pad.fromDataURL(signature);
  }, [pad, signature]);

  return (
    <>
      <div
        id='signature-pad'
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          overflow: 'hidden',
          border: '1px black dashed',
          borderRadius: '5px',
        }}
      >
        <canvas />
      </div>
      <div className='d-flex justify-content-end gap-4 mt-2'>
        <button
          type='button'
          className='btn btn-secondary'
          onClick={() => clear()}
        >
          Limpar <FaEraser />
        </button>
        <div className='d-flex gap-2'>
          <CustomButton
            type='button'
            className='btn btn-primary'
            handleClick={sign}
          >
            Salvar
          </CustomButton>
        </div>
      </div>
    </>
  );
}
